import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Translate } from 'react-localize-redux';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';

import Modal from '../../components/modal';
import BACKGROUND from './images/character-modal-background.svg';

const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(${BACKGROUND}) -9em -2em/25em no-repeat;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 70vh;
  padding: 0 1em;

  &.enter {
    opacity: 0;
  }

  &.enter-active {
    opacity: 1;
    transition: 350ms ease;
  }

  &.exit {
    opacity: 0;
    transition: 350ms ease;
  }
`;

const Id = styled.div`
  border-bottom: 0.3em solid #111111;
  font-size: 0.9em;
  font-weight: bold;
  margin: 0 auto;
  max-width: calc(14em / 0.9);
  position: relative;

  &::before {
    background: #111111;
    bottom: -0.3em;
    content: '';
    display: block;
    left: -1.3em;
    position: absolute;
    top: 0.3em;
    transform: skewX(-45deg);
    transform-origin: left bottom;
    width: 0.5em;
  }

  > span {
    margin-left: 0.8em;
  }
`;

const Image = styled.img`
  display: block;
  margin: 1em auto 0;
  max-width: 100%;
  width: 14em;
`;

const Name = styled.h2`
  font-family: 'Noto Serif JP', serif;
  font-size: 1.8em;
  text-align: center;
  margin: 0.5em 0 0;
`;

const Furigana = styled.div`
  margin-top: 0.25em;
  text-align: center;

  > span {
    background: #111111;
    color: #ffffff;
    display: inline-block;
    padding: 0.4em 1em;
  }
`;

const Bio = styled.div`
  margin: 1.5em auto 1em;
  max-width: 30em;

  > p {
    margin: 0;
  }
`;

const Button = styled.div`
  cursor: pointer;
  font-size: 2.5em;
  background: ${props => props.theme.primary};
  color: white;
  position: absolute;
  width: 1.2em;
  height: 1.2em;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Next = styled(Button)`
  right: -0.6em;
  top: 50%;
  transform: translateY(-50%);
`;

const Previous = styled(Button)`
  left: -0.6em;
  top: 50%;
  transform: translateY(-50%);
`;

const CharacterModal = ({ character, image, onNext, onPrevious, ...rest }) => (
  <Modal
    {...rest}
    positionalChildren={
      <>
        <Background />
        <Previous onClick={onPrevious}>
          <FiChevronLeft />
        </Previous>
        <Next onClick={onNext}>
          <FiChevronRight />
        </Next>
      </>
    }
  >
    <SwitchTransition>
      <CSSTransition key={character} timeout={350}>
        <Content>
          <Id>
            <span>
              <Translate id={`psyLandingPage.characters.${character}.id`} />
            </span>
          </Id>
          <Translate>
            {({ translate }) => (
              <Image
                alt={translate(`psyLandingPage.characters.${character}.name`)}
                src={image}
              />
            )}
          </Translate>
          <Name>
            <Translate id={`psyLandingPage.characters.${character}.name`} />
          </Name>
          <Furigana>
            <span>
              <Translate
                id={`psyLandingPage.characters.${character}.furigana`}
              />
            </span>
          </Furigana>
          <Bio>
            <p>
              <Translate id={`psyLandingPage.characters.${character}.bio.1`} />
            </p>
            <p>
              <Translate id={`psyLandingPage.characters.${character}.bio.2`} />
            </p>
          </Bio>
        </Content>
      </CSSTransition>
    </SwitchTransition>
  </Modal>
);

export default CharacterModal;
